export const company_name = 'א.ים ארץ ומלואה (מקבוצת מגדים)'